export const FONT_BASE = {
  CALIBRE_REGULAR: 'calibre-regular',
  CALIBRE_BOLD: 'calibre-bold',
  PIXEL_OPERATOR_HB_8: 'pixel-operator-hb-8',
  PIXEL_OPERATOR_HB: 'pixel-operator-hb',
  PIXEL_OPERATOR: 'pixel-operator',
  OPEN_SANS_BOLD: 'open-sans-bold',
  OPEN_SANS_REGULAR: 'open-sans-regular',
  CSS: ['fonts.css'],
};

export const FONTS = {
  BOOT: [FONT_BASE],
  APP: [],
};
